// Scrolling agruments at the bottom of the configurator
// > the price bubble
import styled from 'styled-components/macro';
import {CSS_MOBILE_BREAKPOINT,CSS_MINIMOBILE_BREAKPOINT,CSS_SMALLDESKTOP_BREAKPOINT,CSS_COLOR_RED,CSS_PADDING} from '../constants';
import euro_ht_svg from '../assets/euro_ht.svg';
import euro_ttc_svg from '../assets/euro_ttc.svg';
import {numberWithSpaces} from '../helpers';
// import RafNumberCounter from "react-number-animator";


const PriceHolder = styled.div`
	display: flex;
	justify-content: center;
	@media ${CSS_MOBILE_BREAKPOINT}{

	}
	.contact-us {
		color: ${CSS_COLOR_RED};
		font-style: italic;
		font-size: 20px;
		display: inline-block;
		text-align:center;
		font-weight: 900;
		align-self:center;
	}
	.bubble,.bubble-micro {
		background-image: linear-gradient(-180deg, #ffea42 50%, #bdaf00 100%);
		border: 1px solid rgba(0,0,0,0.5);
		font-style: italic;
		display: inline-block;
		font-weight: 900;
		color: ${CSS_COLOR_RED};
	}
	.bubble-micro {
		padding: 2px 4px 2px 3px;
		border-radius: 2px;
		margin-bottom:3px;
		box-shadow: 0 1px 2px 0 rgba(0,0,0,0.2);
		font-size: 14px;
		text-shadow: 1px 1px 0 #fff;
		text-shadow: 1px 1px 0 #fff,-1px 1px 0 #fff,-1px -1px 0 #fff,1px -1px 0 #fff;
		small {
			font-size: 12px;
		}
	}
	.bubble {
		padding: 0 46px 2px 14px;
		border-radius: 12px;
		line-height: 64px;
		box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
		font-size: 48px;
		text-shadow: 3px 3px 0 #fff;
		text-shadow: 1px 1px 0 #fff,-1px 1px 0 #fff,-1px -1px 0 #fff,1px -1px 0 #fff,2px 2px 0 #fff,3px 3px 0 #fff,4px 4px 0 #fff;
		white-space: nowrap;
		@media ${CSS_MOBILE_BREAKPOINT}{
			line-height: 46px;
			font-size: 36px;
			padding: 0 40px 2px 6px;
		}
		position: relative;
		span.sign {
			position: absolute;
			top: 14px;
			right: 0px;
			height: 42px;
			width: 38px;
			background-repeat: no-repeat;
			&.euro_ht {
				background-image: url(${euro_ht_svg});
			}
			&.euro_ttc {
				background-image: url(${euro_ttc_svg});
			}
			@media ${CSS_MOBILE_BREAKPOINT}{
				top: 8px;
				bottom: 6px;
				height: auto;
				background-size: contain;
				width: 34px;
			}
		}
	}
	.bubble+.recap {
		margin-left: ${CSS_PADDING};
	}
	.recap {
		font-size: 16px;
		display: flex;
		flex-direction: column;
		justify-content: center;

		@media ${CSS_MINIMOBILE_BREAKPOINT}, ${CSS_SMALLDESKTOP_BREAKPOINT}{
			font-size: 12px;
		}
		b,u {
			font-weight: 700;
			white-space: nowrap;
		}
		u {
			text-decoration: underline;
			color: ${CSS_COLOR_RED};
		}
		b sup {
			font-size: 70%;
			top: -0.3em;
		}
	}
`;


function Price(props) {

	const rounded_price = Math.ceil(props.price);
	const other_price_mode = (props.mode==='ttc')?'ht':'ttc';

	const tax_rate = 0.2;
	let other_price;
	if(other_price_mode === 'ttc'){
		other_price = rounded_price*(1+tax_rate);
	}else{
		other_price = rounded_price/(1+tax_rate);
	}
	let other_price_text;
	let other_price_text_small = false;
	if(other_price%1){
		other_price_text = numberWithSpaces(Math.floor(other_price))+'€';
		other_price_text_small = Math.round((other_price%1)*100);
	}else{
		other_price_text = numberWithSpaces(other_price)+'€';
	}

	//<RafNumberCounter value={rounded_price} totalSteps={15} outputFormatter={(v)=>numberWithSpaces(Math.max(v,rounded_price))}/>
	return (
		<PriceHolder>
			{props.price?<>
				{!props.micro&&<div className="bubble">
					{numberWithSpaces(rounded_price)}
					<span className={'sign euro_'+props.mode}></span>
				</div>}
				<div className="recap">
					<div className="recap-content">
						{props.micro&&<><span className="bubble-micro">
							{numberWithSpaces(rounded_price)}€ <small>HT</small>
						</span><br/></>}
						soit <b>{other_price_text}{other_price_text_small&&(<sup>{other_price_text_small}</sup>)} {other_price_mode.toUpperCase()}</b>
						{props.delivery&&<><br/><u>{!props.micro&&'prix '}livré et déchargé</u></>}
					</div>
				</div>
			</>:<div className="contact-us">Contactez-nous <br/>pour obtenir votre devis</div>}
		</PriceHolder>
	);
}

export default Price;
